// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  transition: all 0.3s ease;
}

.react-pdf__Document {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: background-color 0.3s ease;
  width: 100%;
  background-color: transparent;
}

.react-pdf__Page {
  margin-bottom: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background-color: white;
  transition: all 0.3s ease;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.react-pdf__Page canvas {
  max-width: 100% !important;
  height: auto !important;
  border-radius: 4px;
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  background-color: white;
  object-fit: contain;
}

.pdf-controls {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  gap: 12px;
}

.pdf-pagination {
  text-align: center;
  margin: 10px 0;
  font-weight: 500;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

/* Dark Mode Styles */
.dark-mode-document {
  background-color: transparent;
}

.dark-mode-page {
  background-color: #2d2d2d;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.dark-mode-page canvas {
  filter: invert(0.9) hue-rotate(180deg);
  background-color: #1a1a1a;
}

/* Enhanced Toolbar */
.pdf-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin-bottom: 16px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.pdf-toolbar-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pdf-toolbar-divider {
  height: 24px;
  width: 1px;
  margin: 0 8px;
}

/* Animation for button hover */
.pdf-toolbar button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

/* Fullscreen styles */
.fullscreen-pdf-container {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 8px;
  overflow: auto;
}

.fullscreen-pdf-document {
  height: calc(100vh - 70px);
  overflow: auto;
  width: 100%;
}

/* Additional fullscreen adjustments */
.pdf-container[data-fullscreen="true"] .react-pdf__Document {
  margin: 0;
  width: 100%;
}

.pdf-container[data-fullscreen="true"] .react-pdf__Page {
  margin-bottom: 0;
  width: 100%;
  overflow: hidden;
}

.pdf-container[data-fullscreen="true"] .react-pdf__Page canvas {
  max-height: calc(100vh - 70px);
  max-width: 100%;
  object-fit: contain;
}

/* Container size optimization */
@media (min-width: 1200px) {
  .pdf-container:not([data-fullscreen="true"]) .react-pdf__Page {
    width: 100%;
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .pdf-container:not([data-fullscreen="true"]) .react-pdf__Page {
    width: 100%;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .pdf-container:not([data-fullscreen="true"]) .react-pdf__Page {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .pdf-container:not([data-fullscreen="true"]) .react-pdf__Page {
    width: 100%;
  }
}

/* Animation for page transitions */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.react-pdf__Page {
  animation: fadeIn 0.3s ease;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .pdf-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pdf-toolbar-group {
    width: 100%;
    justify-content: center;
    margin-bottom: 8px;
  }
  
  .pdf-toolbar-divider {
    display: none;
  }
  
  .react-pdf__Page {
    padding: 0 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/Components/PDFViewer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,mCAAmC;AACnC;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pdf-container {\n  max-width: 100%;\n  margin: 0 auto;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.react-pdf__Document {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: background-color 0.3s ease;\n  width: 100%;\n  background-color: transparent;\n}\n\n.react-pdf__Page {\n  margin-bottom: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  background-color: white;\n  transition: all 0.3s ease;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.react-pdf__Page canvas {\n  max-width: 100% !important;\n  height: auto !important;\n  border-radius: 4px;\n  display: block;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  background-color: white;\n  object-fit: contain;\n}\n\n.pdf-controls {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n  gap: 12px;\n}\n\n.pdf-pagination {\n  text-align: center;\n  margin: 10px 0;\n  font-weight: 500;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n/* Dark Mode Styles */\n.dark-mode-document {\n  background-color: transparent;\n}\n\n.dark-mode-page {\n  background-color: #2d2d2d;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n}\n\n.dark-mode-page canvas {\n  filter: invert(0.9) hue-rotate(180deg);\n  background-color: #1a1a1a;\n}\n\n/* Enhanced Toolbar */\n.pdf-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  margin-bottom: 16px;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.pdf-toolbar-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pdf-toolbar-divider {\n  height: 24px;\n  width: 1px;\n  margin: 0 8px;\n}\n\n/* Animation for button hover */\n.pdf-toolbar button:hover {\n  transform: translateY(-2px);\n  transition: transform 0.2s ease;\n}\n\n/* Fullscreen styles */\n.fullscreen-pdf-container {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  padding: 8px;\n  overflow: auto;\n}\n\n.fullscreen-pdf-document {\n  height: calc(100vh - 70px);\n  overflow: auto;\n  width: 100%;\n}\n\n/* Additional fullscreen adjustments */\n.pdf-container[data-fullscreen=\"true\"] .react-pdf__Document {\n  margin: 0;\n  width: 100%;\n}\n\n.pdf-container[data-fullscreen=\"true\"] .react-pdf__Page {\n  margin-bottom: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.pdf-container[data-fullscreen=\"true\"] .react-pdf__Page canvas {\n  max-height: calc(100vh - 70px);\n  max-width: 100%;\n  object-fit: contain;\n}\n\n/* Container size optimization */\n@media (min-width: 1200px) {\n  .pdf-container:not([data-fullscreen=\"true\"]) .react-pdf__Page {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n  .pdf-container:not([data-fullscreen=\"true\"]) .react-pdf__Page {\n    width: 100%;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .pdf-container:not([data-fullscreen=\"true\"]) .react-pdf__Page {\n    width: 100%;\n  }\n}\n\n@media (max-width: 767px) {\n  .pdf-container:not([data-fullscreen=\"true\"]) .react-pdf__Page {\n    width: 100%;\n  }\n}\n\n/* Animation for page transitions */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.react-pdf__Page {\n  animation: fadeIn 0.3s ease;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .pdf-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pdf-toolbar-group {\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 8px;\n  }\n  \n  .pdf-toolbar-divider {\n    display: none;\n  }\n  \n  .react-pdf__Page {\n    padding: 0 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
